import { COLORS } from "shared/consts";
import { toRem } from "shared/helpers";
import styled, { css } from "styled-components";

const mobile = (styles: any) => css`
  ${({ theme }) => theme?.isWidget && styles};

  @media (max-width: 768px) {
    ${styles}
  }
`;

export const DayDetailsContainer = styled.div`
  position: relative;
  overflow: hidden;
`;

export const Section = styled.div`
  display: grid;
  flex-direction: column;
  gap: ${toRem(16)};
  line-height: ${toRem(20)};
  padding: 0 0 ${toRem(16)} ${toRem(16)};
  overflow: scroll;
  scroll-behavior: smooth;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
  -ms-overflow-style: none;
  cursor: grab;
  user-select: none;
  &::-webkit-scrollbar {
    display: none;
  }
  ${mobile(css`
    padding: 0 0 ${toRem(16)} 0;
    overflow: visible;
  `)}
`;

export const RowsTemp = styled.div`
  font-size: ${toRem(14)};
`;

export const Panel = styled.div<{
  canPrev?: boolean;
  canNext?: boolean;
}>`
  background-color: ${COLORS.BG.ELEVATED.M};
  padding: ${toRem(16)};
  border-radius: ${toRem(16)};

  box-shadow: var(--shadow-bottom-m);
`;

export const PanelWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${toRem(8)};
`;

export const Cells = styled.div`
  display: grid;
  grid-auto-flow: column;
  justify-content: space-evenly;
  grid-auto-columns: ${toRem(90)};
  grid-auto-rows: ${toRem(44)};
  gap: ${toRem(8)};

  ${mobile(css`
    grid-auto-columns: ${toRem(73.5)};
    grid-auto-rows: ${toRem(52)};
  `)}
`;

export const Cell = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${toRem(4)};
`;

export const FeelsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${toRem(8)};
`;

export const FeelsRow = styled(Cells)`
  grid-auto-rows: auto;
`;

export const FeelsLabel = styled.div`
  font-size: ${toRem(14)};
  color: ${COLORS.FG.SOFT};
`;

export const FeelsValue = styled.div`
  font-size: ${toRem(14)};
  display: flex;
  flex-direction: column;
  align-items: center;
  color: ${COLORS.FG.SOFT};
`;

export const BlockTitle = styled.div`
  font-size: ${toRem(14)};
  font-weight: 500;
  color: ${COLORS.FG.DEFAULT};
`;

export const Row = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${COLORS.FG.SOFT};
  font-size: ${toRem(12)};
  gap: ${toRem(4)};
`;

export const Precip = styled.div`
  font-size: ${toRem(12)};
`;

export const Icon = styled.img`
  width: ${toRem(24)};
  height: ${toRem(24)};
  object-fit: contain;
`;

export const Temp = styled.div`
  font-size: ${toRem(14)};
  font-weight: 500;
`;

export const WindSpeed = styled.div`
  font-size: ${toRem(14)};
  font-weight: 400;
  color: ${COLORS.FG.DEFAULT};
`;

export const WindDir = styled.div`
  display: flex;
  gap: ${toRem(2)};
  align-items: center;
  font-size: ${toRem(12)};
  color: ${COLORS.FG.SOFT};
`;

export const Arrow = styled.span`
  font-size: ${toRem(18)};
`;

export const RowHumidity = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${COLORS.FG.DEFAULT};
  font-size: ${toRem(14)};
  gap: ${toRem(4)};
`;
